import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import { ADDADHERENSE, ADHERENSEHISTORY, AGREEMENTHISTORY, ALLADHERENSE, ATTINFOS, CANCELPLANS, CANCELREQUEST, CREW_LOGIN, CREW_PAGE, DOCUMENTS, ENTERPRISEREGISTER, FORGOTPASSWORD, HISTORY, HOME_LOGGED, LANDING_PAGE, MYCONTRACTS, PARTICULAR, PFFORM, PLANCHANGEVALIDATION, PREREGISTER, RESETPASSWORD, SELECTDEPENDENTS, SELECTEMAIL, SELECTPLANMODIFICATION, TYPEREGISTER, VALIDATION } from '../core/app-urls';
import CrewLogin from '../pages/CrewLogin';
import Crew from '../pages/Crew';
import HomeLogged from '../pages/HomeLogged';
import Validation from '../pages/Validation';
import EmailSelection from '../pages/SelectEmail';
import ChangePassword from '../pages/ChangePassword';
import ForgotPassword from '../pages/ForgotPassword';
import HistoricoAdesoes from '../pages/History';
import EnterpriseRegister from '../pages/EnterpriseRegister';
import PreRegister from '../pages/PersonRegister';
import MyContracts from '../pages/MyContracts';
import TypeRegister from '../pages/TypeRegister';
import Particular from '../pages/TypeRegister/Particular';
import PFform from '../pages/PFform';
import AddAdherense from '../pages/AddAdherense';
import AllAdherense from '../pages/AddAdherense/AllAdherense';
import AdherenseHistory from '../pages/AdherenseHistory';
import AttInfos from '../pages/AttInfos';
import CancelPlans from '../pages/CancelPlans';
import CancelRequest from '../pages/CancelRequest';
import SelectPlanModification from '../pages/SelectPlanModification';
import PlanChangeValidation from '../pages/PlanChangeValidation';
import AgreementHistory from '../pages/AgreementHistory';
import SelectDependets from '../pages/SelectDependents';
import Documents from '../pages/Documents';


export default function AppRoutes() {
    return (<>
        <Router>
            <Routes>
                <Route path={LANDING_PAGE} element={<Home />} > </Route>
                <Route path={CREW_LOGIN} element={<CrewLogin />} > </Route>
                <Route path={CREW_PAGE} element={<Crew />} > </Route>
                <Route path={HOME_LOGGED} element={<HomeLogged />} > </Route>
                <Route path={VALIDATION} element={<Validation />} > </Route>
                <Route path={SELECTEMAIL} element={<EmailSelection />} > </Route>
                <Route path={RESETPASSWORD} element={<ChangePassword />} > </Route>
                <Route path={FORGOTPASSWORD} element={<ForgotPassword />} > </Route>
                <Route path={HISTORY} element={<HistoricoAdesoes />} > </Route>
                <Route path={ENTERPRISEREGISTER} element={<EnterpriseRegister />} > </Route>
                <Route path={PREREGISTER} element={<PreRegister />} > </Route>
                <Route path={MYCONTRACTS} element={<MyContracts />} > </Route>
                <Route path={TYPEREGISTER} element={<TypeRegister />} > </Route>
                <Route path={PARTICULAR} element={<Particular />} > </Route>
                <Route path={PFFORM} element={<PFform />} > </Route>
                <Route path={ADDADHERENSE} element={<AddAdherense />} > </Route>
                <Route path={ALLADHERENSE} element={<AllAdherense />} > </Route>
                <Route path={ADHERENSEHISTORY} element={<AdherenseHistory />} > </Route>
                <Route path={ATTINFOS} element={<AttInfos />} > </Route>
                <Route path={CANCELPLANS} element={<CancelPlans />} > </Route>
                <Route path={CANCELREQUEST} element={<CancelRequest />} > </Route>
                <Route path={SELECTPLANMODIFICATION} element={<SelectPlanModification />} > </Route>
                <Route path={PLANCHANGEVALIDATION} element={<PlanChangeValidation />} > </Route>
                <Route path={AGREEMENTHISTORY} element={<AgreementHistory />} > </Route>
                <Route path={SELECTDEPENDENTS} element={<SelectDependets />} > </Route>
                <Route path={DOCUMENTS} element={<Documents />} > </Route>
            </Routes>
        </Router>
    </>);
}